declare let mxConstants: any;
import * as util from '../styles.util';
import {ServerStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';

export function textStyleKeeper(styles: ServerStyleObject, textObj: any): StyleKeeper {
  return {
    original: () => styles,
    fontCss: () => util.fontCss(styles),
    mxCellCss: () => {
      const result = {};

      result['html'] = 1;

      if (styles.borderColor) {
        result['strokeColor'] = styles.borderColor;
      }

      if (styles.backgroundColor) {
        result['fillColor'] = styles.backgroundColor;
      }

      result['shadow'] = styles.shadow ? 1 : 0;
      result['fontColor'] = styles.fontColor;
      result['fontStyle'] = util.calculateFontStyle(styles);
      result['fontFamily'] = styles.font;
      result['fontSize'] = parseInt(styles.fontSize);
      result['whiteSpace'] = 'wrap';
      result['overflow'] = 'hidden';
      result['align'] = styles.textAlign ? styles.textAlign : 'center';
      result['verticalAlign'] = styles.verticalAlign ? styles.verticalAlign : 'middle';

      if (textObj && textObj.position && textObj.position.rotation) {
        result['rotation'] = textObj.position.rotation;
      }

      if (textObj && textObj.locked) {
        result['locked'] = +textObj.locked;
      }

      result['strokeWidth'] = styles.borderWidth;

      return 'text;' + util.objectToString(result, '=');
    },
    getRandomAngle: (): string => {
      return String(Math.floor(Math.random() * 31) - 15);
    }
  };
}
